import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './index.css'
import { useAuthStore } from './stores/auth'
import { useThemeStore } from './stores/themeStore'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// Écouteur d'événement pour réinitialiser tous les stores
window.addEventListener('pinia-reset-stores', () => {
  // Récupérer tous les stores enregistrés dans Pinia
  const storeIds = Object.keys(pinia.state.value)
  
  for (const storeId of storeIds) {
    // Ne pas réinitialiser certains stores spécifiques
    if (storeId !== 'auth' && storeId !== 'theme') { 
      try {
        const store = pinia._s.get(storeId)
        if (store && typeof store.$reset === 'function') {
          store.$reset()
        }
      } catch (error) {
        // Gestion silencieuse de l'erreur lors de la réinitialisation d'un store
      }
    }
  }
})

// Initialiser l'état d'authentification
const authStore = useAuthStore()
authStore.initializeAuth()
// Configurer explicitement les intercepteurs Axios pour l'authentification
authStore.setupAxiosInterceptors()

// Initialiser le thème
const themeStore = useThemeStore()

// Initialiser l'application après l'initialisation du thème et de l'authentification
Promise.all([
  themeStore.initializeTheme(),
  // L'initialisation de l'authentification est déjà effectuée de manière synchrone
])
.then(() => {
  // Vérifier si l'utilisateur est authentifié et synchroniser les préférences si nécessaire
  if (authStore.isAuthenticated) {
    // Forcer une synchronisation des préférences avec la base de données
    themeStore.syncWithDatabase()
      .catch(syncError => {
        console.error('Erreur lors de la synchronisation des préférences:', syncError)
      })
  }
})
.catch(error => {
  console.error('Erreur lors de l\'initialisation:', error)
})
.finally(() => {
  // Monter l'application une fois toutes les initialisations terminées
  app.mount('#app')
})

